export default "__VITE_ASSET__DoxgIvqX__"